export default {
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    width: '100%',
    maxWidth: 600,
    '& .MuiFormLabel-root.MuiInputLabel-shrink': {
      color: 'text.dark',
    },
  },
  editorLabel: {
    mb: 1,
  },
  contributorsWrapper: {},
  contributorsChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1.25,
  },
};
